import { render, staticRenderFns } from "./InventoryFilters.vue?vue&type=template&id=310b67c6"
import script from "./InventoryFilters.vue?vue&type=script&lang=js"
export * from "./InventoryFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports